import BaseClient from '@/app/model/api/response/baseApiClient'

class ExternalLinkContentsListApi extends BaseClient {
  public getExternalLinkContentsList (data: any) {
    const path = '/v1/external-link-contents'
    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({})

    if (data.external_link_id !== undefined) {
      params.append('external_link_id', data.external_link_id)
    }
    if (data.variety_id !== undefined) {
      params.append('variety_id', data.variety_id)
    }
    if (data.district_id !== undefined) {
      params.append('district_id', data.district_id)
    }

    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new ExternalLinkContentsListApi()
